import component from './XDataGrid';

export const XDataGrid: any = component;
